(() => {
  const offer = document.querySelector('[data-mewing-bonus]');
  if (!offer || offer.dataset.initialized === 'true') return;
  offer.dataset.initialized = 'true';

  const manualId = Number(offer.dataset.manualVariant);
  const serumId = Number(offer.dataset.serumVariant);
  const endsAt = Date.parse(offer.dataset.endsAt);
  const productSection = offer.closest('[id^="MainProduct-"]');
  const days = offer.querySelector('[data-bonus-days]');
  const hours = offer.querySelector('[data-bonus-hours]');
  const minutes = offer.querySelector('[data-bonus-minutes]');
  const seconds = offer.querySelector('[data-bonus-seconds]');
  const timer = offer.querySelector('[data-bonus-timer]');

  const setButtonLabel = (label) => {
    document.querySelectorAll('.main-product-atc .main-atc__label__text, .sticky-atc__label__text').forEach((node) => {
      node.textContent = label;
    });
  };

  const updateTimer = () => {
    const remaining = Number.isFinite(endsAt) ? Math.max(0, endsAt - Date.now()) : 0;
    const active = remaining > 0;
    offer.dataset.campaignActive = String(active);
    offer.hidden = !active;
    productSection?.classList.toggle('mewing-black-month', active);
    setButtonLabel(active ? offer.dataset.ctaLabel : offer.dataset.defaultCtaLabel);
    const totalSeconds = Math.ceil(remaining / 1000);
    const d = Math.floor(totalSeconds / 86400);
    const h = Math.floor((totalSeconds % 86400) / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    if (days) days.textContent = String(d).padStart(2, '0');
    if (hours) hours.textContent = String(h).padStart(2, '0');
    if (minutes) minutes.textContent = String(m).padStart(2, '0');
    if (seconds) seconds.textContent = String(s).padStart(2, '0');
    timer?.setAttribute('aria-label', `${d} ${days?.nextElementSibling?.textContent || 'd'} ${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`);
  };

  updateTimer();
  window.setInterval(updateTimer, 1000);

  const form = document.querySelector('.main-product-form form[data-type="add-to-cart-form"]');
  if (!form) return;

  const jsonRoute = (route) => route.endsWith('.js') ? route : `${route}.js`;

  const setLoading = (button, loading) => {
    const spinner = button?.querySelector('.loading-overlay__spinner');
    if (loading) {
      button?.setAttribute('aria-disabled', 'true');
      spinner?.classList.remove('hidden');
    } else {
      button?.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    }
  };

  const addBundle = async (button) => {
    if (window.__mencoreBonusSubmitting === true) return;
    window.__mencoreBonusSubmitting = true;
    form.dataset.bonusSubmitting = 'true';
    setLoading(button, true);

    try {
      const mainId = Number(form.querySelector('input[name="id"]')?.value);
      const requiredIds = [mainId, manualId, serumId];
      if (!requiredIds.every((id) => Number.isFinite(id) && id > 0)) {
        throw new Error('Invalid bundle variant configuration.');
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer?.renderContents) {
        throw new Error('Cart drawer is unavailable.');
      }
      cartDrawer.setActiveElement?.(button);
      const sectionIds = cartDrawer.getSectionsToRender?.().map((section) => section.id)
        || ['cart-drawer', 'cart-icon-bubble'];
      const sectionRequest = { sections: sectionIds, sections_url: window.location.pathname };

      const cartResponse = await fetch(jsonRoute(window.routes?.cart_url || '/cart'), {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!cartResponse.ok) throw new Error(await cartResponse.text());
      const cart = await cartResponse.json();
      const items = [];
      const repairUpdates = {};

      const ensureSingleLine = (variantId, properties) => {
        const lines = cart.items.filter((item) => Number(item.variant_id) === variantId);
        if (lines.length === 0) {
          items.push({ id: variantId, quantity: 1, ...(properties ? { properties } : {}) });
          return;
        }

        const [keeper, ...duplicates] = lines;
        if (keeper.quantity !== 1) repairUpdates[keeper.key] = 1;
        duplicates.forEach((line) => {
          repairUpdates[line.key] = 0;
        });
      };

      ensureSingleLine(mainId);
      // Campaign expiry removes the gifts, never the ability to buy the main product.
      if (Number.isFinite(endsAt) && Date.now() < endsAt) {
        ensureSingleLine(manualId, { _mencore_bonus: 'manual' });
        ensureSingleLine(serumId, { _mencore_bonus: 'serum' });
      }

      let refreshedCart;
      if (Object.keys(repairUpdates).length > 0) {
        const repairResponse = await fetch(jsonRoute(window.routes?.cart_update_url || '/cart/update'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: repairUpdates, ...(items.length === 0 ? sectionRequest : {}) }),
        });
        if (!repairResponse.ok) throw new Error(await repairResponse.text());
        refreshedCart = await repairResponse.json();
      }

      if (items.length > 0) {
        const addResponse = await fetch(jsonRoute(window.routes?.cart_add_url || '/cart/add'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, ...sectionRequest }),
        });
        if (!addResponse.ok) throw new Error(await addResponse.text());
        refreshedCart = await addResponse.json();
      }

      if (!refreshedCart?.sections?.['cart-drawer']) {
        // Reopening an unchanged cart only needs HTML; a render retry must never add products again.
        const sectionUrl = new URL(window.location.pathname, window.location.origin);
        sectionUrl.searchParams.set('sections', sectionIds.join(','));
        const refreshResponse = await fetch(sectionUrl.href, { cache: 'no-store' });
        if (!refreshResponse.ok) throw new Error(await refreshResponse.text());
        refreshedCart = { sections: await refreshResponse.json() };
      }
      if (!refreshedCart.sections?.['cart-drawer']) {
        throw new Error('Cart drawer section did not render.');
      }

      const renderedDrawer = new DOMParser().parseFromString(refreshedCart.sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
      if (!renderedDrawer?.querySelector('#CartDrawer')) {
        throw new Error('Cart drawer section is incomplete.');
      }
      refreshedCart.id = mainId;
      // The theme replaces only the drawer's contents, leaving its empty-state class behind.
      cartDrawer.classList.toggle('is-empty', renderedDrawer.classList.contains('is-empty'));
      cartDrawer.renderContents(refreshedCart);
    } catch (error) {
      const message = form.closest('product-form')?.querySelector('.product-form__error-message');
      if (message) {
        message.textContent = window.cartStrings?.error || 'Unable to add this offer. Please try again.';
        message.closest('[role="alert"]')?.removeAttribute('hidden');
      }
      const stickyError = button?.querySelector('.sticky-atc__error');
      if (stickyError) {
        stickyError.textContent = window.cartStrings?.error || 'Unable to add this offer. Please try again.';
        stickyError.style.display = 'inline';
      }
      console.error('MenCore bonus offer:', error);
    } finally {
      window.__mencoreBonusSubmitting = false;
      form.dataset.bonusSubmitting = 'false';
      setLoading(button, false);
    }
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (window.__mencoreBonusSubmitting === true) return;
    addBundle(form.querySelector('[type="submit"]'));
  }, true);

  document.addEventListener('click', (event) => {
    const mainButton = form.querySelector('[type="submit"]');
    const stickyButton = event.target.closest('sticky-atc [id^="SectionAtcBtn-"]');
    const clickedButton = event.target.closest('button');
    const button = clickedButton === mainButton ? mainButton : stickyButton;
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (window.__mencoreBonusSubmitting === true) return;
    addBundle(button);
  }, true);
})();
